<template>
  <div class="search-bar">
    <div class="search-bar__container">
      <el-input :placeholder="placeholder" v-model="query" style="width: 90%" @input="onQuery">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: { type: String, default: 'Rechercher...' },
  },
  data() {
    return {
      query: '',
    };
  },
  methods: {
    onQuery() {
      this.$emit('onQuery', this.query);
    },
  },
};
</script>
<style lang="stylus" scoped>
.search-bar {
  width: 100%;
  height: 90px;
  background: #7688a7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.search-bar__container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 30px;
}
</style>
